import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Select, Switch, InputNumber, Divider, message } from 'antd';
import axios from 'axios';
import { getRolesApi } from '../../services/roles';
import { createUserApi } from '../../services/users';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { getTenants } from '../../services/tenantApi';
import { getCompany } from '../../services/companyApi';

const { Option } = Select;

const CreateUserForm = () => {
const {tenantId,companyId} = useParams()

  const [form] = Form.useForm();
  const [roles, setRoles] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedTenantId,setSelectedTenantId] = useState(tenantId||null)
// console.log(tenantId,"tenant")
  // Load dropdown data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [roleRes, 
            tenantRes,
            //  companyRes
        ] = await Promise.all([
            getRolesApi({companyId,tenantId}),
            getTenants(),
            // getCompany(),
        ]);
       
        setRoles(roleRes);
        setTenants(tenantRes);
        // setCompanies(companyRes);
      } catch (err) {
        message.error('Failed to load dropdown data');
      }
    };
    fetchData();
  }, []);

  const getCompanyData = async ()=>{
    let res = await getCompany({tenantId:selectedTenantId})
    setCompanies(res)
  }
  useEffect(()=>{
        getCompanyData()
  },[selectedTenantId])

  // Submit handler
  const onFinish = async (values) => {
    try {
        let payload = {...values}
        if(tenantId) payload={...payload,tenant:tenantId}
        if(companyId)payload={...payload,tenant:selectedTenantId,company:companyId}
     let res = await createUserApi(payload)
     if(!res?.sucess) return toast.error(res?.message||'not created!')
        toast.success('created sucessfully!')

      form.resetFields();
    } catch (err) {
      message.error(err.response?.data?.error || 'Failed to create user');
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      initialValues={{ isActive: true, onSalary: false }}
    >
      <Divider>User Info</Divider>

      <Form.Item name="name" label="Name" rules={[{ required: true }]}>
        <Input />
      </Form.Item>

      <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
        <Input />
      </Form.Item>

      <Form.Item name="mobile" label="Mobile" rules={[{ required: true }]}>
        <Input />
      </Form.Item>

      <Form.Item name="password" label="Password" rules={[{ required: true, min: 6 }]}>
        <Input.Password />
      </Form.Item>

      <Form.Item name={['role', '_id']} label="Role" rules={[{ required: true }]}>
        <Select placeholder="Select role">
          {roles.map((r) => (
            <Option key={r._id} value={r._id}>
              {r.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
     {tenantId===undefined&&companyId===undefined&& <Form.Item name="tenant" label="Tenant">
        <Select placeholder="Select tenant (if any)"
        onChange={(value) => setSelectedTenantId(value)}>
          {tenants.map((t) => (
            <Option key={t._id} value={t._id}>
              {t.tenantName}
            </Option>
          ))}
        </Select>
      </Form.Item>}

      {companyId===undefined&&<Form.Item name="company" label="Company">
        <Select placeholder="Select company (if any)" disabled={selectedTenantId===null&&tenantId===undefined?true:false}>
          {companies.map((c) => (
            <Option key={c._id} value={c._id}>
              {c.name}
            </Option>
          ))}
        </Select>
      </Form.Item>}

      <Form.Item name="isActive" label="Is Active" valuePropName="checked">
        <Switch />
      </Form.Item>

      <Form.Item name="onSalary" label="On Salary" valuePropName="checked">
        <Switch />
      </Form.Item>

      <Form.Item noStyle shouldUpdate={(prev, curr) => prev.onSalary !== curr.onSalary}>
        {({ getFieldValue }) =>
          getFieldValue('onSalary') ? (
            <Form.Item name="salary" label="Salary (₹)" rules={[{ required: true }]}>
              <InputNumber min={0} style={{ width: '100%' }} />
            </Form.Item>
          ) : null
        }
      </Form.Item>

      <Divider>Bank Details</Divider>

      <Form.Item name={['bankDetails', 'holderName']} label="Account Holder Name">
        <Input />
      </Form.Item>

      <Form.Item name={['bankDetails', 'accountNumber']} label="Account Number">
        <Input />
      </Form.Item>

      <Form.Item name={['bankDetails', 'ifscCode']} label="IFSC Code">
        <Input />
      </Form.Item>

      <Form.Item name={['bankDetails', 'bankName']} label="Bank Name">
        <Input />
      </Form.Item>

      <Form.Item name={['bankDetails', 'branch']} label="Branch">
        <Input />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Create User
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CreateUserForm;
